import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarFornecedor(api, parametros) {
    parametros.operacao = 'buscarFornecedor';

    let retorno = {};
    
    await api.santriGET('/rest/fornecedor', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RFornecedor.js